import theme from '@styles/theme';

import type { CheckInListItemDtoStatus } from '@/api/generated/model';
import type { ReceiveStatus, CheckInMethod, ScanResultStatus } from '../types/types';

// 리셉션 진행 상태 라벨
export const RECEPTION_STATUS_LABEL: Record<CheckInListItemDtoStatus, string> = {
	IN_PROGRESS: '대회 진행중',
	PREPARING: '대회 준비중'
};

// 리셉션 진행 상태 배지 색상
export const getReceptionStatusColor = (status: CheckInListItemDtoStatus) => {
	switch (status) {
		case 'IN_PROGRESS':
			return {
				fontColor: theme.colors.whiteColor,
				bgColor: theme.colors.activeGreen
			};
		case 'PREPARING':
		default:
			return {
				fontColor: theme.colors.whiteColor,
				bgColor: theme.colors.activeOrange
			};
	}
};

// 기념품 수령 상태 라벨
export const RECEIVE_STATUS_LABEL: Record<ReceiveStatus, string> = {
	RECEIVED: '수령',
	NOT_RECEIVED: '미수령'
};

// 기념품 수령 상태 배지 색상
export const getReceiveStatusColor = (status: ReceiveStatus) => {
	switch (status) {
		case 'RECEIVED':
			return {
				fontColor: theme.colors.whiteColor,
				bgColor: theme.colors.activeGreen
			};
		case 'NOT_RECEIVED':
		default:
			return {
				fontColor: theme.colors.deepGrayFontColor,
				bgColor: theme.colors.ultraLightGrayBorder
			};
	}
};

// 체크인 처리 방식 라벨
export const CHECK_IN_METHOD_LABEL: Record<CheckInMethod, string> = {
	QR: 'QR',
	MANUAL: '수동처리'
};

// 진행률(퍼센트) 문자열 포맷 (소수 첫째자리 유지)
export const formatProgressRate = (rate: number): string => `${rate.toFixed(1)}%`;

// 진행 카운트 문자열 포맷 (완료 / 전체)
export const formatProgressCount = (current: number, total: number): string => `${current.toLocaleString()} / ${total.toLocaleString()}`;

/* ============================================================
 * 스캔 모드 결과 표현
 * ============================================================ */

// 스캔 결과 배지 라벨
export const SCAN_RESULT_BADGE_LABEL: Record<ScanResultStatus, string> = {
	CHECKABLE: '체크인 가능',
	CANCELED: '취소된 예약',
	ALREADY_RECEIVED: '체크인 불가',
	TIME_OUT: '시간 외 처리',
	INVALID: '인식할 수 없는 코드'
};

// 스캔 결과 안내 문구 (에러 배너)
export const SCAN_RESULT_MESSAGE: Record<ScanResultStatus, string> = {
	CHECKABLE: '체크인 가능',
	CANCELED: '취소된 예약 - 환불/취소된 신청입니다. 본부석으로 안내하세요.',
	ALREADY_RECEIVED: '체크인 불가 - 이미 배번을 수령한 참가자입니다',
	TIME_OUT: '시간 외 처리 - 현재 해당 티켓 진행 오픈시간이 열리지 않았습니다. 대회 진행중인 상태시에 다시 시도해주세요.',
	INVALID: '인식할 수 없는 코드 - QR이 훼손되었거나 이 대회의 티켓이 아닙니다. 직접 검색으로 처리하세요.'
};

// 스캔 대기 상태 안내 문구 (창 포커스 여부에 따라 노출)
export const SCAN_READY_MESSAGE = '스캔 준비 완료 - 리더기 QR 입력을 기다리고 있는 상태입니다.';
export const SCAN_PAUSED_MESSAGE = '스캔 일시 정지 - 화면을 클릭해주세요.';

// 참가자 상세 없이 표시되는 결과의 카드 내 안내 문구
export const SCAN_RESULT_NOTE: Partial<Record<ScanResultStatus, string>> = {
	TIME_OUT: '시간 외 처리가 되는 QR입니다.',
	INVALID: '훼손된 QR코드입니다.'
};

// 결과 상태가 체크인 가능 여부
export const isCheckable = (status: ScanResultStatus): boolean => status === 'CHECKABLE';

// 스캔 결과 카드 색상 (체크인 가능=블루 / 그 외=오렌지)
export const getScanResultColor = (status: ScanResultStatus) => {
	if (isCheckable(status)) {
		return {
			pointColor: theme.colors.activeBlue,
			bgColor: '#EAF3FF'
		};
	}
	return {
		pointColor: theme.colors.activeRedOrange,
		bgColor: '#FFEDE3'
	};
};
